import Vue from 'vue';
import i18n from '@/i18n/index';

const ToastMessageBusiness = new Vue({
    i18n,
    methods: {

        showInfo(detail = 'toast.info.detail', summary = 'toast.info.summary') {
            this.send('info', summary, detail);
        },
        showSuccess(detail = 'toast.success.detail', summary = 'toast.success.summary') {
            this.send('success', summary, detail);
        },
        showWarn(detail = 'toast.warn.detail', summary = 'toast.warn.summary') {
            this.send('warn', summary, detail);
        },
        showError(detail = 'toast.error.detail', summary = 'toast.error.summary') {
            this.send('error', summary, detail);
        },
        send(severity, summary, detail){
            this.$toast.add({severity: severity, summary: this.$t(summary), detail: this.$t(detail), life: 3000});
        }
    }

});

export default ToastMessageBusiness;
